import type { FC } from 'react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';
import { XMarkIcon } from '@interstate/components/Icons/XMarkIcon';
import { dealLockHooks } from '@makemydeal/dr-dash-components';
import * as firstPencilActionCreators from '@makemydeal/dr-dash-store/actions/firstPencilActionCreators';
import * as firstPencilSelectors from '@makemydeal/dr-dash-store/selectors/firstPencilSelectors';

export const FirstPencilSelectedLenders: FC = () => {
    const dispatch = useDispatch();
    const isLocked = dealLockHooks.useIsDealLocked();
    const selectedProgram = useSelector(firstPencilSelectors.getSelectedProgram);

    const handleRemove = useCallback(() => {
        dispatch(firstPencilActionCreators.programCleared());
    }, [dispatch]);

    if (!selectedProgram) {
        return null;
    }

    const lender = selectedProgram.program.lenderCode || selectedProgram.program.lenderLegalName || '';

    return (
        <Box
            data-testid="first-pencil-selected-lenders"
            sx={{
                marginLeft: 'auto',
                width: '16rem',
                flexShrink: 0,
                paddingBottom: '3rem'
            }}
        >
            <Typography variant="body-md" color="base.color.gray.600" sx={{ margin: '0 0 0.5rem' }}>
                Selected Lenders
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography variant="body-md" data-testid="first-pencil-selected-lender">
                    {lender}
                </Typography>
                <button
                    type="button"
                    aria-label={`Remove ${lender}`}
                    data-testid="first-pencil-remove-selected-lender"
                    disabled={isLocked}
                    onClick={handleRemove}
                    style={{ background: 'transparent', border: 'none', padding: 0, cursor: 'pointer', display: 'inline-flex' }}
                >
                    <XMarkIcon />
                </button>
            </Box>
        </Box>
    );
};
